import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "../../../hooks";
import { Field } from "../miProfile/Field";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { unSelectOpportunity } from "../../../store/opportunity/opportunitySlice";
import { DateInput } from "../DateInput";
import { editOpportunity } from "../../helpers/opportunity";
import { OnConvertForm } from "./OnConvertForm";
import { NumberInput } from "../NumberInput";
import { VisibilityList } from "./VisibilityList";
import { fetchData } from "../../helpers/getData/fetchData";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  maxWidth: 500,
  minWidth: 300,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  padding: "25px 25px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  height: "70%",
};

export const EditOportunity = ({
  setHidden,
  setReloadData,
  vehiclesList,
  name,
  userList,
}) => {
  const { t } = useTranslation("global");
  const { dataToAction } = useSelector((state) => state.opportunity);
  const dispatch = useDispatch();
  const [onConvert, setOnConvert] = useState(false);
  const [userWithActivePosition, setUserWithActivePosition] = useState([]);

  const [formValues, handleInputChange, reset] = useForm({
    ...dataToAction,
    dateOpportunity: dataToAction.dateOpportunity,
    participationValuation: "",
  });

  const {
    dateOpportunity,
    reservationDeadline,
    investmentType,
    urlVideo,
    startup,
    status,
    vehicle,
    participationValuation,
    visibility,
  } = formValues;
  const initialChecked = !name
    ? userList?.filter((user) => visibility?.includes(user.id))
    : [];
  const [checked, setChecked] = useState(initialChecked);

  const handleCancel = () => {
    reset();
    dispatch(unSelectOpportunity());
    setHidden(false);
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    const data = {
      ...formValues,
      visibility: JSON.stringify(checked.map(({ id }) => id)),
      clubFilter: JSON.stringify(formValues.clubFilter),
    };
    await editOpportunity(
      data,
      t("opportunities.succesMsgEdit"),
      t("opportunities.errorMsg")
    );
    setReloadData((prevState) => !prevState);
    setHidden(false);
  };

  const onConvertClick = () => {
    setOnConvert(true);
  };

  useEffect(() => {
    fetchData(
      setUserWithActivePosition,
      `/user/getUsersWithActivePosition/${dataToAction.startupId}`,
      t
    );
    // eslint-disable-next-line no-undef, react-hooks/exhaustive-deps
  }, [startup]);

  return (
    <>
      <Modal
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: 900 }}
      >
        {!onConvert ? (
          <Box sx={style}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="baseline"
              sx={{ height: "50px" }}
            >
              <Typography
                color="primary"
                marginBottom="10px"
                variant="h5"
                fontWeight={700}
              >
                {name === "positions"
                  ? t("positions.editPosition")
                  : t("opportunities.editOportunity")}
              </Typography>
              <IconButton color="primary" onClick={handleCancel}>
                <CloseRoundedIcon />
              </IconButton>
            </Stack>
            <form
              onSubmit={onSubmit}
              style={{
                padding: "10px 5px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
              }}
            >
              <Stack
                sx={{
                  height: "calc(70vh - 200px)",
                  overflowY: "auto",
                  paddingBottom: "10px",
                  paddingRight: "20px",
                }}
              >
                <Grid container direction="row" width="100%">
                  <Grid item xs={12} padding="0 5px">
                    <Field
                      name={startup}
                      title="startup"
                      handleInputChange={handleInputChange}
                      translation="opportunities"
                      isDisabled={true}
                    />
                  </Grid>
                </Grid>
                {name !== "positions" && (
                  <>
                    <Grid container direction="row" width="100%">
                      <Grid item xs={12} padding="0 5px">
                        <Typography variant="overline" color="secondary">
                          {t("opportunities.status")}
                        </Typography>
                        <Autocomplete
                          disablePortal
                          options={["Activo", "Inactivo"]}
                          size="small"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              name="status"
                            />
                          )}
                          value={status}
                          onSelect={handleInputChange}
                          required
                        />
                      </Grid>
                    </Grid>

                    <Grid container direction="row" width="100%">
                      <Grid item xs={12} md={6} padding="0 5px">
                        <DateInput
                          name={dateOpportunity}
                          title="dateOpportunity"
                          handleInputChange={handleInputChange}
                          translation="opportunities"
                        />
                      </Grid>
                      <Grid item xs={12} md={6} padding="0 5px">
                        <DateInput
                          name={reservationDeadline}
                          title="reservationDeadline"
                          handleInputChange={handleInputChange}
                          translation="opportunities"
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
                <Grid container direction="row" width="100%">
                  <Grid item xs={12} padding="0 5px">
                    <Field
                      name={urlVideo}
                      title="urlVideo"
                      handleInputChange={handleInputChange}
                      translation="opportunities"
                    />
                  </Grid>
                </Grid>

                <Stack direction="column" width="100%" gap={0}>
                  <Typography variant="overline" color="secondary">
                    {t("opportunities.vehicle")}
                  </Typography>
                  <Autocomplete
                    disablePortal
                    options={vehiclesList}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        name="vehicle"
                      />
                    )}
                    value={vehicle}
                    onSelect={handleInputChange}
                    fullWidth
                    required
                  />
                </Stack>
                {name === "positions" && (
                  <Grid container direction="row" width="100%">
                    <Grid item xs={12} padding="0 5px">
                      <NumberInput
                        translation="opportunities"
                        name={participationValuation}
                        title="participationValuation"
                        handleInputChange={handleInputChange}
                        required={true}
                      />
                    </Grid>
                  </Grid>
                )}

                {investmentType === "Préstamo Convertible" && (
                  <Grid container direction="row" width="100%" marginTop={2}>
                    <Grid item xs={12} padding="0 5px">
                      <Button
                        fullWidth
                        onClick={onConvertClick}
                        color="secondary"
                        variant="outlined"
                      >
                        {t("opportunities.converter")}
                      </Button>
                    </Grid>
                  </Grid>
                )}
                {!name && (
                  <VisibilityList
                    formValues={formValues}
                    handleInputChange={handleInputChange}
                    userList={userList}
                    checked={checked}
                    setChecked={setChecked}
                    isInitial={true}
                    edit={true}
                    userWithActivePosition={userWithActivePosition}
                  />
                )}
              </Stack>

              <Stack sx={{ heigth: "80px" }}>
                <Divider sx={{ margin: "30px 0px 15px 0px" }} />

                <Grid container direction="row" width="100%">
                  <Grid item xs={12} md={6} padding="0 5px">
                    <Button fullWidth onClick={handleCancel} variant="text">
                      {t("createPassword.cancelButton")}
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={6} padding="0 5px">
                    <Button fullWidth type="submit" variant="contained">
                      {t("createPassword.principalButton")}
                    </Button>
                  </Grid>
                </Grid>
              </Stack>
            </form>
          </Box>
        ) : (
          <OnConvertForm
            style={style}
            setHidden={setHidden}
            setReloadData={setReloadData}
          />
        )}
      </Modal>
    </>
  );
};
